export default __webpack_public_path__ + "static/media/intro-background.907251b7.png";